{
  "GENERAL": {
    "CLOSE": "Închide",
    "SHOWING_RESULTS": "Showing {firstIndex}-{lastIndex} of {totalCount} items",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Caută",
      "EMPTY_STATE": "Niciun rezultat găsit"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Sunt necesare cel puțin {count}"
  }
}
